import { PaymentAccount } from './types'

// Mock data for demo purposes - payment accounts/invoices
export const mockPaymentAccounts: PaymentAccount[] = [
  {
    id: 1,
    account_number: '135',
    date: '2025-11-20',
    supplier_name: 'DEMO SUPPLIER SRL',
    supplier_address: 'Moldova, Chișinău, str. Demo 10, MD-2000',
    supplier_fiscal_code: '1000000000001',
    supplier_iban: 'MD72DE0000000000000000001',
    supplier_bank: 'BC DEMO BANK SA, filiala nr.1 Chișinău',
    supplier_bank_code: 'DEMOMD2X001',
    supplier_vat: '0200001',
    client_name: 'DEMO CLIENT SRL',
    client_address: 'str. Exemplu 15, Chișinău, Republica Moldova',
    client_fiscal_code: '1010101010101',
    client_vat: '0200001',
    client_beneficiary_bank: 'BC DEMO BANK S.A. Chisinau, Moldova',
    client_swift_code: 'DEMOMD2X MD92DE000000000000000001',
    services: [
      {
        id: 1,
        description: 'Servicii de publicitate (ecrane LED)',
        quantity: '---',
        price: 1555.0,
        amount_without_vat: 1295.83,
        vat_amount: 259.17,
        total: 1555.0
      }
    ],
    total_without_vat: 1295.83,
    vat_amount: 259.17,
    total: 1555.0,
    currency: 'EUR',
    status: 'unpaid',
    created_at: '2025-11-20T10:00:00Z'
  },
  {
    id: 2,
    account_number: '136',
    date: '2025-11-25',
    supplier_name: 'DEMO SUPPLIER SRL',
    supplier_address: 'Moldova, Chișinău, str. Demo 10, MD-2000',
    supplier_fiscal_code: '1000000000001',
    supplier_iban: 'MD72DE0000000000000000001',
    supplier_bank: 'BC DEMO BANK SA, filiala nr.1 Chișinău',
    supplier_bank_code: 'DEMOMD2X001',
    supplier_vat: '0200001',
    client_name: 'SAMPLE COMPANY SRL',
    client_address: 'str. Exemplu 25, Chișinău',
    client_fiscal_code: '1020202020202',
    client_vat: '0200002',
    client_beneficiary_bank: 'BC DEMO BANK S.A. Chisinau, Moldova',
    client_swift_code: 'DEMOMD2X MD92DE000000000000000002',
    services: [
      {
        id: 1,
        description: 'Servicii de publicitate outdoor',
        quantity: '---',
        price: 2500.0,
        amount_without_vat: 2083.33,
        vat_amount: 416.67,
        total: 2500.0
      }
    ],
    total_without_vat: 2083.33,
    vat_amount: 416.67,
    total: 2500.0,
    currency: 'EUR',
    status: 'paid',
    created_at: '2025-11-25T14:30:00Z'
  },
  {
    id: 3,
    account_number: '137',
    date: '2025-12-01',
    supplier_name: 'DEMO SUPPLIER SRL',
    supplier_address: 'Moldova, Chișinău, str. Demo 10, MD-2000',
    supplier_fiscal_code: '1000000000001',
    supplier_iban: 'MD72DE0000000000000000001',
    supplier_bank: 'BC DEMO BANK SA, filiala nr.1 Chișinău',
    supplier_bank_code: 'DEMOMD2X001',
    supplier_vat: '0200001',
    client_name: 'TEST MARKETING SRL',
    client_address: 'bd. Exemplu 50, Chișinău',
    client_fiscal_code: '1030303030303',
    client_vat: '0200003',
    client_beneficiary_bank: 'BC DEMO BANK S.A. Chisinau, Moldova',
    client_swift_code: 'DEMOMD2X MD92DE000000000000000003',
    services: [
      {
        id: 1,
        description: 'Servicii de publicitate indoor',
        quantity: '---',
        price: 1800.0,
        amount_without_vat: 1500.0,
        vat_amount: 300.0,
        total: 1800.0
      }
    ],
    total_without_vat: 1500.0,
    vat_amount: 300.0,
    total: 1800.0,
    currency: 'EUR',
    status: 'unpaid',
    created_at: '2025-12-01T09:15:00Z'
  }
]
